import { useContext } from 'react'

import { CampaignsContext } from './consts'

export const useCampaigns = () => {
  const context = useContext(CampaignsContext)

  if (!context) {
    throw new Error('useCampaigns must be used within a CampaignsProvider')
  }

  return context
}
